import mutations from './treatmentStatisticCount.mutations'
import actions from './treatmentStatisticCount.actions'
import getters from './treatmentStatisticCount.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
